import { Listbox } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Controller } from "react-hook-form";
import { CreateRuleSetState } from "../hooks/use-create-ruleset";

type CreateRuleSetFormProps = {
  state: CreateRuleSetState;
};

const CreateRuleSetForm = (props: CreateRuleSetFormProps) => {
  const createRulesetState: CreateRuleSetState = props.state;

  return (
    <div className="mx-8 md:mx-36 grid md:grid-cols-2 md:gap-8 py-8">
      <div className="w-full">
        <label className="text-sm tracking-[0.07rem]">RULE SET NAME</label>
        <input
          className={`rounded p-2 mt-2 border w-full ${
            createRulesetState.formState.errors &&
            createRulesetState.formState.errors.name
              ? "border-red-600 focus:border-red-600"
              : "border-primary-blue"
          }`}
          placeholder="Rule Set Name"
          {...createRulesetState.register("name", { required: true })}
        />
        {createRulesetState.formState.errors &&
          createRulesetState.formState.errors.name &&
          createRulesetState.formState.errors.name.type === "required" && (
            <p className="text-red-500 text-sm">Required</p>
          )}
      </div>
      <div className="w-full">
        <div className="relative w-full">
          <label className="text-sm tracking-[0.07rem]">STATE</label>
          <Controller
            name="stateId"
            control={createRulesetState.control}
            defaultValue={createRulesetState.control._formValues["stateId"]}
            rules={{ validate: (value) => value !== -1 }}
            render={({ fieldState, field, formState }) => (
              <Listbox value={field.value} onChange={field.onChange}>
                <Listbox.Button className="w-full mt-2 py-2 px-4 rounded border border-primary-blue bg-white min-w-64 flex items-center justify-between">
                  <div>
                    {
                      createRulesetState.states.find(
                        (s) => s.id === field.value
                      )?.name
                    }
                  </div>
                  <ChevronDownIcon className="h-4 w-4 ml-8" />
                </Listbox.Button>
                <Listbox.Options className="absolute w-full h-64 overflow-y-auto mt-2 p-2 bg-white rounded-md z-10 shadow-lg">
                  {createRulesetState.states &&
                    createRulesetState.states.map((state) => (
                      <Listbox.Option
                        key={`s-${state.id}`}
                        value={state.id}
                        className={`p-2 border-b last:border-b-0 cursor-pointer ${
                          state.id === field.value ? "bg-blue-100 rounded" : ""
                        }`}
                      >
                        {state.name}
                      </Listbox.Option>
                    ))}
                </Listbox.Options>
              </Listbox>
            )}
          />
        </div>
      </div>
      <div className="w-full">
        <div className="relative w-full">
          <label className="text-sm tracking-[0.07rem]">ELECTION TYPE</label>
          <Controller
            name="electionTypeId"
            control={createRulesetState.control}
            defaultValue={
              createRulesetState.control._formValues["electionTypeId"]
            }
            rules={{ validate: (value) => value >= 0 }}
            render={({ fieldState, field, formState }) => (
              <Listbox value={field.value} onChange={field.onChange}>
                <Listbox.Button className="w-full mt-2 py-2 px-4 rounded border border-primary-blue bg-white min-w-64 flex items-center justify-between">
                  <div>
                    {
                      createRulesetState.electionTypes.find(
                        (et) => et.id === field.value
                      )?.name
                    }
                  </div>
                  <ChevronDownIcon className="h-4 w-4 ml-8" />
                </Listbox.Button>
                <Listbox.Options className="absolute w-full max-h-64 overflow-y-auto mt-2 p-2 bg-white rounded-md z-10 shadow-lg">
                  {createRulesetState.electionTypes &&
                    createRulesetState.electionTypes.map((electionType) => (
                      <Listbox.Option
                        key={`s-${electionType.id}`}
                        value={electionType.id}
                        className={`p-2 border-b last:border-b-0 cursor-pointer ${
                          electionType.id === field.value
                            ? "bg-blue-100 rounded"
                            : ""
                        }`}
                      >
                        {electionType.name}
                      </Listbox.Option>
                    ))}
                </Listbox.Options>
              </Listbox>
            )}
          />
        </div>
      </div>
      <div className="w-full">
        <label className="text-sm tracking-[0.07rem]">RULE SET OPTIONS</label>
        <div className="mt-2 flex items-center gap-4">
          <label className="tracking-[0.07rem] mt-2 flex item-center justify-around">
            <input
              type="checkbox"
              className="p-2 h-6 w-6 border border-primary-blue mr-2"
              {...createRulesetState.register("isActive")}
            />
            <span className="h-6">Active Rule Set</span>
          </label>
          <label className="tracking-[0.07rem] mt-2 flex item-center justify-around">
            <input
              type="checkbox"
              className="p-2 h-6 w-6 border border-primary-blue mr-2"
              {...createRulesetState.register("isInternal")}
            />
            <span className="h-6">Internal Rule Set</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default CreateRuleSetForm;
